import * as types from './pprManageActionType'
const initialState = {
  busStation: [],
  counterList: [],
  managePprTableData: [],
  issuePprTableData: [],
  skipPprTableData: [],
  tranferPprTableData: [],
}
const pprManageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGE_PPRTABLEDATA:
      return { ...state, managePprTableData: action.payload };
    case types.ISSUE_PPRTABLEDATA:
      return { ...state, issuePprTableData: action.payload };
    case types.BUS_STATION:
      return { ...state, busStation: action.payload };
    case types.COUNTER_LIST:
      return { ...state, counterList: action.payload };
    case types.SKIP_PPRTABLEDATA:
      return { ...state, skipPprTableData: action.payload };
    case types.TRASFER_PPRTABLEDATA:
      return { ...state, tranferPprTableData: action.payload };
    default:
      return state;
  }
}

export default pprManageReducer
